import React, { useEffect, useState } from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import store from '../../../App/store';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import { useParams } from 'react-router';

import RolePermissions from '../../CommonModals/Permissions';
import fetchMethodRequest from "../../../../config/service";
/**@FormModal */
import FormModal from '../../../Form/FormModal';
// config file
const Roles = (props) => {

  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(window.location.href.includes("edit"));
  const [addSelectedRecord, setAddSelectedRecord] = useState(window.location.href.includes("create"));
  const [viewSelectedRecord, setViewSelectedRecord] = useState(window.location.href.includes("view"));
  const [menuList, setMenuList] = useState();
  const params = useParams();
  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions('Roles');
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
    getMenuListFromServer();

  }, []);

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id)
      return rowData
    }
  }
  const getMenuListFromServer = () => {
    let filterCriteria = {},
      url;
    filterCriteria.sortfield = "sequenceNo";
    filterCriteria.direction = "asc";
    url = `menus?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest('GET', url)
      .then((res) => {
        if (res && res.menulists && res.menulists.length > 0) {
          setMenuList(res.menulists)
        }
      }).catch((err) => { return err })
  };

  const getTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true
      },
      {
        show: true,
        textAlign: "center",
        width: 47,
        field: "Sno",
        header: "Sno",
        label: "Sno",
        filter: false,
        sortable: false,
        displayInSettings: true,
        placeholder: "Search"
      },

      {
        show: true,
        textAlign: "center",
        mobile: true,
        width: 300,
        field: "role",
        label: "Role",
        fieldType: "Link",
        header: "Role",
        filter: false,
        sortable: true,
        displayInSettings: true
      },

      {
        show: true,
        textAlign: "center",
        width: 80,
        field: "status",
        label: "Status",
        mobile: true,
        fieldType: "Badge",
        header: "Status",
        filter: false,
        displayInSettings: true,

        sortable: false,
        options: [
          { value: "Active", color: "success" },
          { value: "Inactive", color: "warning" },
          { value: "Pending", color: "danger" }
        ],
        filterElement: [
          { label: "All", value: null },
          { label: "Active", value: "Active" },
          { label: "Pending", value: "Pending" },
          { label: "Inactive", value: "Inactive" }
        ]
      },
      // {"name":"roleType","type":"dropDown","placeholder":"RoleType","width":90,"label":"RoleType","header":"RoleType","derivedValue":"roleType=undefined","actions":[],"actionsNumber":[],"id":"roleType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","fieldType":"dropDown","controllerName":null,"options":[{"label":"Employee","value":"Employee"},{"label":"Manager","value":"Manager"},{"label":"Admin","value":"Admin"}],"textAlign":"Center","show":true,"required":true,"disabled":true,"field":"roleType","addFormOrder":3,"editFormOrder":3,"mobile":true,"displayInSettings":true},{"actions":[],"actionsNumber":[],"controllerName":null,"derivedValue":"levels=undefined","displayinaddForm":"true","displayineditForm":"true","width":50,"displayinlist":"true","field":"levels","header":"Levels","id":"levels","label":"Levels","name":"levels","globalSearchField":"false","placeholder":"Levels","show":true,"textAlign":"Center","type":"number","disabled":true,"required":false,"addFormOrder":4,"editFormOrder":4,"mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","addFormOrder":8,"editFormOrder":8,"mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","addFormOrder":9,"editFormOrder":9,"mobile":true,"displayInSettings":true},
      { "name": "roleType", "type": "dropDown", "placeholder": "RoleType", "width": 90, "label": "RoleType", "header": "RoleType", "derivedValue": "roleType=undefined", "actions": [], "actionsNumber": [], "id": "roleType", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "fieldType": "dropDown", "controllerName": null, "options": [{ "label": "Employee", "value": "Employee" }, { "label": "Manager", "value": "Manager" }, { "label": "Admin", "value": "Admin" }], "textAlign": "Center", "show": true, "required": true, "disabled": false, "field": "roleType", "addFormOrder": 3, "editFormOrder": 3, "defField": true, "globalSearchField": "false", "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "actions": [], "actionsNumber": [], "controllerName": null, "derivedValue": "levels=undefined", "displayinaddForm": "true", "displayineditForm": "true", "width": 50, "displayinlist": "true", "field": "levels", "header": "Levels", "id": "levels", "label": "Levels", "name": "levels", "globalSearchField": "true", "placeholder": "Levels", "show": true, "textAlign": "Center", "type": "number", "disabled": false, "required": false, "addFormOrder": 4, "editFormOrder": 4, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "name": "created", "type": "date", "placeholder": "Created", "label": "Created", "width": 90, "header": "Created", "derivedValue": "created=undefined", "actions": [], "actionsNumber": [], "id": "created", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "globalSearchField": "true", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": false, "show": true, "field": "created", "addFormOrder": 8, "editFormOrder": 8, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "name": "updated", "type": "date", "placeholder": "Updated", "label": "Updated", "width": 90, "header": "Updated", "derivedValue": "updated=undefined", "actions": [], "actionsNumber": [], "id": "updated", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "globalSearchField": "true", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": false, "show": true, "field": "updated", "addFormOrder": 9, "editFormOrder": 9, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true },
      {
        show: true,
        textAlign: "center",
        width: "10%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];
    return data;
  };
  const getFormFields = () => {
    return [
      {
        name: "role",
        type: "text",
        placeholder: "Role",
        label: "Role",
        id: "role",
        width: 50,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        displayinregisterForm: "true",
        show: true,
        disabled: false,
        addFormOrder: 5,
        editFormOrder: 3,
        defField: true,
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        required: true
      },
      {
        id: "status",
        name: "status",
        label: "Status",
        type: "dropDown",
        placeholder: "Status",
        value: "",
        required: true,
        options: config.formFieldStatusTypes,
        addFormOrder: 2,
        editFormOrder: 2,
        required: true,
        show: true

      },
      {
        id: "roleType",
        name: "roleType",
        label: "Role Type",
        type: "dropDown",
        placeholder: "Role Type",
        value: "",
        required: true,
        disabled: false,
        options: [
          { label: "Employee", value: "Employee" },
          { label: "Manager", value: "Manager" },
          { label: "Admin", value: "Admin" },
        ],
        width: 90,
        show: true,
        addFormOrder: 4,
        editFormOrder: 4,
        defField: true,
        derivedValue: "roleType=undefined",
        controllerName: null,
        actions: [],
        actionsNumber: [],
        displayinaddForm: true,
        displayineditForm: true,
        displayinlist: true,
        displayInSettings: true,
        mobile: true,
        isFieldRequired: false,
        globalSearchField: false,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        id: "levels",
        name: "levels",
        label: "Levels",
        type: "number",
        placeholder: "Levels",
        value: "",
        required: false,
        disabled: false,
        width: 50,
        show: true,
        addFormOrder: 5,
        editFormOrder: 5,
        defField: true,
        derivedValue: "levels=undefined",
        controllerName: null,
        actions: [],
        actionsNumber: [],
        displayinaddForm: true,
        displayineditForm: true,
        displayinlist: true,
        displayInSettings: true,
        mobile: true,
        isFieldRequired: false,
        globalSearchField: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        id: "permission",
        name: "permission",
        label: "Permission",
        type: "permission",
        placeholder: "Permission",
        value: "",
        required: true,
        addFormOrder: 3,
        editFormOrder: 3,
      },
    ];
  };


  const getMobileTableFields = () => {
    let data = [{ "textAlign": "center", "width": 47, "field": "Sno", "header": "Sno", "filter": false, "sortable": false, "placeholder": "Search" },
    { "textAlign": "center", "width": 80, "field": "role", "header": "Role", "filter": false, "sortable": true },
    // { "textAlign": "center", "width": 80, "field": "permission", "header": "Permissions", "filter": true, "sortable": true },
    { "textAlign": "left", "width": 70, "field": "Actions", "header": "Actions", "filter": false, "sortable": false }, { "name": "roleType", "type": "dropDown", "placeholder": "RoleType", "width": 90, "label": "RoleType", "header": "RoleType", "derivedValue": "roleType=undefined", "actions": [], "actionsNumber": [], "id": "roleType", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "fieldType": "dropDown", "controllerName": null, "options": [{ "label": "Employee", "value": "Employee" }, { "label": "Manager", "value": "Manager" }, { "label": "Admin", "value": "Admin" }], "textAlign": "Center", "show": true, "required": true, "disabled": true, "field": "roleType", "addFormOrder": 3, "editFormOrder": 3, "mobile": true, "displayInSettings": true }, { "actions": [], "actionsNumber": [], "controllerName": null, "derivedValue": "levels=undefined", "displayinaddForm": "true", "displayineditForm": "true", "width": 50, "displayinlist": "true", "field": "levels", "header": "Levels", "id": "levels", "label": "Levels", "name": "levels", "globalSearchField": "false", "placeholder": "Levels", "show": true, "textAlign": "Center", "type": "number", "disabled": true, "required": false, "addFormOrder": 4, "editFormOrder": 4, "mobile": true, "displayInSettings": true }, { "name": "created", "type": "date", "placeholder": "Created", "label": "Created", "width": 90, "header": "Created", "derivedValue": "created=undefined", "actions": [], "actionsNumber": [], "id": "created", "displayinaddForm": "false", "displayineditForm": "false", "displayinlist": "true", "globalSearchField": "false", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": true, "show": true, "field": "created", "addFormOrder": 8, "editFormOrder": 8, "mobile": true, "displayInSettings": true }, { "name": "updated", "type": "date", "placeholder": "Updated", "label": "Updated", "width": 90, "header": "Updated", "derivedValue": "updated=undefined", "actions": [], "actionsNumber": [], "id": "updated", "displayinaddForm": "false", "displayineditForm": "false", "displayinlist": "true", "globalSearchField": "false", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": true, "show": true, "field": "updated", "addFormOrder": 9, "editFormOrder": 9, "mobile": true, "displayInSettings": true },
    { "name": "roleType", "type": "dropDown", "placeholder": "RoleType", "width": 90, "label": "RoleType", "header": "RoleType", "derivedValue": "roleType=undefined", "actions": [], "actionsNumber": [], "id": "roleType", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "fieldType": "dropDown", "controllerName": null, "options": [{ "label": "Employee", "value": "Employee" }, { "label": "Manager", "value": "Manager" }, { "label": "Admin", "value": "Admin" }], "textAlign": "Center", "show": true, "required": true, "disabled": false, "field": "roleType", "addFormOrder": 3, "editFormOrder": 3, "defField": true, "globalSearchField": "false", "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "actions": [], "actionsNumber": [], "controllerName": null, "derivedValue": "levels=undefined", "displayinaddForm": "true", "displayineditForm": "true", "width": 50, "displayinlist": "true", "field": "levels", "header": "Levels", "id": "levels", "label": "Levels", "name": "levels", "globalSearchField": "true", "placeholder": "Levels", "show": true, "textAlign": "Center", "type": "number", "disabled": false, "required": false, "addFormOrder": 4, "editFormOrder": 4, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "name": "created", "type": "date", "placeholder": "Created", "label": "Created", "width": 90, "header": "Created", "derivedValue": "created=undefined", "actions": [], "actionsNumber": [], "id": "created", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "globalSearchField": "true", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": false, "show": true, "field": "created", "addFormOrder": 8, "editFormOrder": 8, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true }, { "name": "updated", "type": "date", "placeholder": "Updated", "label": "Updated", "width": 90, "header": "Updated", "derivedValue": "updated=undefined", "actions": [], "actionsNumber": [], "id": "updated", "displayinaddForm": "true", "displayineditForm": "true", "displayinlist": "true", "globalSearchField": "true", "controllerId": null, "fieldType": "Date", "dateFormat": "YYYY-MM-DD HH:mm:ss", "textAlign": "Center", "disabled": false, "show": true, "field": "updated", "addFormOrder": 9, "editFormOrder": 9, "defField": true, "isFieldRequired": "false", "mobile": true, "displayInSettings": true, "tDisplay": true },]

    return data;
  };
  const saveDataToServer = async (item, field, value) => {
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `roles/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }

        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }


  return (
    <>
      {menuList &&
        <DataTables
          {...props}
          // MobileTableFields={getMobileTableFields}
          getTableFields={getTableFields}
          formFields={getFormFields}

          actionsTypes={[{
            'name': 'Delete',
            "options": [
              { 'label': 'Delete', 'value': 'Delete', 'show': rolePermission && rolePermission == "Edit" ? true : false, "multiple": true, },
            ]
          },
          {
            'name': 'Admin',
            'action': saveDataToServer,
            "options": [
              { 'label': 'Admin', "field": "roleType", 'value': 'Admin', 'show': rolePermission && rolePermission == "Edit" ? true : false, "multiple": false, },
            ]
          },
          {
            'name': 'Manager',
            'action': saveDataToServer,
            "options": [
              { 'label': 'Manager', "field": "roleType", 'value': 'Manager', 'show': rolePermission && rolePermission == "Edit" ? true : false, "multiple": false, },
            ]
          },
          {
            'name': 'Employee',
            'action': saveDataToServer,
            "options": [
              { 'label': 'Employee', "field": "roleType", 'value': 'Employee', 'show': rolePermission && rolePermission == "Edit" ? true : false, "multiple": false, },
            ]
          },
          ]}
          exportRequired={true}
          printRequired={false}
          addRequired={rolePermission && rolePermission == "Edit" ? true : false}
          // addRequried={rolePermission && rolePermission == "Edit" ? true : false}
          editRequired={rolePermission && rolePermission == "Edit" ? true : false}
          deleteRequired={rolePermission && rolePermission == "Edit" ? true : false}
          viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          sample={false}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          menuList={menuList}
          globalSearchFieldName='role'
          globalSearch={'Role'}
          type='Roles'
          displayName='Roles'
          dateSearchRequired={undefined}
          searchInDateRangeField={"undefined"}
          apiUrl={"roles"}
          routeTo='roles'
          statusValue={props.filterValue ? props.filterValue : null}
          displayViewOfForm='screen'
          apiResponseKey='roles'
          entityType='role'
          selectedId={params.id}

        />
      }
    </>

  );

}

export default Roles;